module.exports = __webpack_public_path__ + "static/media/pic6@2x.dd10656d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic6@2x.png
// module id = 1399
// module chunks = 0